"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truthy = truthy;
function truthy(value) {
    return !!value;
}
//# sourceMappingURL=types.js.map